// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import AbstractAnimationChannel from '../../animationpack/clip/AbstractAnimationChannel';
import MathUtils from '../../math/MathUtils';

/**
 * An animation source channel consisting of float value samples. These samples are interpolated between key frames. Potential uses for
 *        this channel include extracting and using forward motion from walk animations, animating colors or texture coordinates, etc.
 */
class InterpolatedFloatChannel extends AbstractAnimationChannel {

 /**
  * @param {string} channelName the name of this channel.
  * @param {Array<number>} times the time samples
  * @param {Array<number>} values our value samples. Entries may be null. Should have as many entries as the times array.
  * @param {string} blendType
  */
 constructor(channelName, times, values, blendType) {
   super(channelName, times, blendType);
   this._values = values ? values.slice(0) : null;
 }

 /*
  * Creates a data item for this type of channel
  * @returns {Array<number>}
  */
 createStateDataObject() {
   return [0.0];
 }

 /*
  * Applies the channels animation state to supplied data item
  * @param {number} sampleIndex
  * @param {number} progressPercent
  * @param {Array<number>} value The data item to apply animation to
  */
 setCurrentSample(sampleIndex, progressPercent, value) {
   value[0] = MathUtils.lerp(progressPercent, this._values[sampleIndex], this._values[sampleIndex + 1]);
 }

 /**
  * Apply a specific index of this channel to a {@link TransformData} object.
  * @param {number} index the index to grab.
  * @param {Array<number>} [store] the TransformData to store in. If null, a new one is created.
  * @returns {Array<number>} our resulting TransformData.
  */
 getData(index, store) {
   const rVal = store || [];
   rVal[0] = this._values[index];
   return rVal;
 }
}

export default InterpolatedFloatChannel;
